import { createContext } from 'react';

const MasterDataContext = createContext([]);

export default MasterDataContext;
